"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var query_exports = {};
__export(query_exports, {
  MessagesQuery: () => MessagesQuery
});
module.exports = __toCommonJS(query_exports);
var import_communication_types = require("@hcengineering/communication-types");
var import_communication_sdk_types = require("@hcengineering/communication-sdk-types");
var import_communication_shared = require("@hcengineering/communication-shared");
var import_communication_yaml = require("@hcengineering/communication-yaml");
var import_uuid = require("uuid");
var import_result = require("../result");
var import_types = require("../types");
var import_window = require("../window");
const GROUPS_LIMIT = 4;
class MessagesQuery {
  constructor(client, workspace, filesUrl, id, params, callback, initialResult) {
    this.client = client;
    this.workspace = workspace;
    this.filesUrl = filesUrl;
    this.id = id;
    this.params = params;
    this.callback = callback;
    const baseLimit = "id" in params && params.id != null ? 1 : this.params.limit ?? import_types.defaultQueryParams.limit;
    this.limit = baseLimit + 1;
    this.params = {
      ...params,
      order: params.order ?? import_types.defaultQueryParams.order
    };
    if (initialResult !== void 0) {
      const messages = initialResult.getResult();
      const count = messages.length;
      if (count < this.limit) {
        this.result = initialResult;
        this.initialized = true;
      } else {
        if (this.params.order === import_communication_types.SortingOrder.Ascending) {
          this.result = new import_result.QueryResult(messages.slice(0, baseLimit), (x) => x.id);
          this.result.setHead(true);
          this.result.setTail(false);
        } else {
          this.result = new import_result.QueryResult(messages.slice(0, baseLimit), (x) => x.id);
          this.result.setHead(false);
          this.result.setTail(true);
        }
      }
      this.initialized = true;
      void this.notify();
    } else {
      this.result = new import_result.QueryResult([], (x) => x.id);
      if (this.isInitLoadingForward()) {
        this.result.setHead(this.params.from == null);
        void this.requestLoadNextPage();
      } else {
        this.result.setTail(this.params.from == null);
        void this.requestLoadPrevPage();
      }
    }
  }
  static {
    __name(this, "MessagesQuery");
  }
  result;
  groupsBuffer = [];
  firstGroup;
  lastGroup;
  firstLoadedGroup;
  lastLoadedGroup;
  lastGroupsDirection;
  limit;
  initialized = false;
  nexLoadedPagesCount = 0;
  prevLoadedPagesCount = 0;
  next = {
    hasMessages: true,
    hasGroups: true,
    buffer: []
  };
  prev = {
    hasMessages: true,
    hasGroups: true,
    buffer: []
  };
  createdPatches = /* @__PURE__ */ new Map();
  tmpMessages = /* @__PURE__ */ new Map();
  isCardRemoved = false;
  async onEvent(event) {
    if (this.isCardRemoved) return;
    switch (event.type) {
      case import_communication_sdk_types.MessageEventType.CreateMessage: {
        await this.onMessageCreatedEvent(event);
        break;
      }
      case import_communication_sdk_types.MessageEventType.UpdatePatch:
      case import_communication_sdk_types.MessageEventType.RemovePatch:
      case import_communication_sdk_types.MessageEventType.ThreadPatch:
      case import_communication_sdk_types.MessageEventType.BlobPatch:
      case import_communication_sdk_types.MessageEventType.AttachmentPatch:
      case import_communication_sdk_types.MessageEventType.ReactionPatch: {
        await this.onPatchEvent(event);
        break;
      }
      case import_communication_sdk_types.CardEventType.RemoveCard:
        await this.onCardRemoved(event);
        break;
    }
  }
  async onCardRemoved(event) {
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.params.card === event.cardId) {
      this.isCardRemoved = true;
      this.result.deleteAll();
      this.result.setHead(true);
      this.result.setTail(true);
      void this.notify();
      return;
    }
    if (this.params.replies === true) {
      const result = this.result.getResult();
      for (const message of result) {
        if (message.thread != null && message.thread.threadId === event.cardId) {
          this.result.update({
            ...message,
            thread: void 0
          });
        }
      }
    }
  }
  async onRequest(event, promise) {
    if (this.isCardRemoved) return;
    switch (event.type) {
      case import_communication_sdk_types.MessageEventType.CreateMessage: {
        await this.onCreateMessageRequest(event, promise);
        break;
      }
    }
  }
  async onCreateMessageRequest(event, promise) {
    if (this.params.card !== event.cardId) return;
    if (this.params.strict === true) return;
    const eventId = event._id;
    if (eventId == null || event.socialId == null) return;
    const tmpId = event.messageId ?? (0, import_uuid.v4)();
    let resultId;
    const tmpMessage = import_communication_shared.MessageProcessor.createFromEvent(event, tmpId);
    if (!this.match(tmpMessage)) return;
    promise.then(async (result) => {
      if (tmpId === result.messageId) return;
      this.tmpMessages.delete(eventId);
      resultId = result.messageId;
      if (this.result instanceof Promise) this.result = await this.result;
      if (this.result.get(resultId) != null) {
        if (this.result.delete(tmpId) != null) {
          await this.notify();
        }
      } else {
        const updatedMessage = this.patchMessage({ ...tmpMessage, id: resultId });
        this.result.delete(tmpId);
        this.insertMessage(this.result, updatedMessage);
        void this.notify();
      }
    }).catch(async () => {
      if (this.result instanceof Promise) this.result = await this.result;
      this.tmpMessages.delete(eventId);
      if (this.result.delete(tmpId) != null) {
        void this.notify();
      }
    });
    if (this.result instanceof Promise) this.result = await this.result;
    if (resultId === void 0 && this.result.isTail()) {
      this.tmpMessages.set(eventId, tmpId);
      this.insertMessage(this.result, tmpMessage);
      void this.notify();
    }
  }
  insertMessage(result, message) {
    if (this.params.order === import_communication_types.SortingOrder.Ascending) {
      result.push(message);
    } else {
      result.unshift(message);
    }
  }
  async unsubscribe() {
    await this.client.unsubscribeQuery(this.id);
  }
  async requestLoadNextPage(notify = true) {
    if (this.isCardRemoved) return { isDone: true };
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.result.isTail()) return { isDone: true };
    const pagePromise = this.loadPage(import_types.Direction.Forward, this.result);
    this.nexLoadedPagesCount++;
    this.result = pagePromise;
    const r = await pagePromise;
    if (notify) {
      await this.notify();
    }
    return { isDone: r.isTail() };
  }
  async requestLoadPrevPage(notify = true) {
    if (this.isCardRemoved) return { isDone: true };
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.result.isHead()) return { isDone: true };
    const pagePromise = this.loadPage(import_types.Direction.Backward, this.result);
    this.prevLoadedPagesCount++;
    this.result = pagePromise;
    const r = await pagePromise;
    if (notify) {
      await this.notify();
    }
    return { isDone: r.isHead() };
  }
  removeCallback() {
    this.callback = () => {
    };
  }
  setCallback(callback) {
    this.callback = callback;
    void this.notify();
  }
  copyResult() {
    if (this.result instanceof Promise) {
      return void 0;
    }
    return this.result.copy();
  }
  isInitLoadingForward() {
    const { order } = this.params;
    if (this.isOneMessageQuery(this.params)) {
      return true;
    }
    return order === import_communication_types.SortingOrder.Ascending;
  }
  async loadPage(direction, result) {
    const { messages, fromDb } = direction === import_types.Direction.Forward ? await this.loadNextMessages(result) : await this.loadPrevMessages(result);
    if (!result.isHead() && direction === import_types.Direction.Backward) {
      result.setHead(messages.length < this.limit);
    }
    if (!result.isTail() && direction === import_types.Direction.Forward) {
      result.setTail(messages.length < this.limit);
    }
    if (messages.length === this.limit && this.limit > 1) {
      const lastMessage = messages.pop();
      if (lastMessage != null && !fromDb) {
        if (direction === import_types.Direction.Forward) {
          this.next.buffer.unshift(lastMessage);
        } else {
          this.prev.buffer.push(lastMessage);
        }
      }
    }
    if (this.params.order === import_communication_types.SortingOrder.Ascending && direction === import_types.Direction.Backward) {
      result.prepend(messages.reverse());
    } else if (this.params.order === import_communication_types.SortingOrder.Descending && direction === import_types.Direction.Forward) {
      result.prepend(messages.reverse());
    } else {
      result.append(messages);
    }
    return result;
  }
  // Load next
  async loadNextMessages(result) {
    const messages = this.next.buffer.splice(0, this.limit);
    if (messages.length >= this.limit) return { messages, fromDb: false };
    while (this.next.hasGroups || this.groupsBuffer.length > 0) {
      await this.loadGroups(import_types.Direction.Forward, result);
      messages.push(...this.next.buffer.splice(0, this.limit - messages.length));
      if (messages.length >= this.limit) return { messages, fromDb: false };
    }
    const dbMessages = await this.findNextMessages(this.limit - messages.length, result);
    this.next.hasMessages = dbMessages.length > 0;
    messages.push(...dbMessages);
    return { messages, fromDb: dbMessages.length > 0 };
  }
  async findNextMessages(limit, result) {
    if (this.next.hasGroups) {
      return [];
    }
    if (result.isTail()) return [];
    const last = this.params.order === import_communication_types.SortingOrder.Ascending ? result.getLast() : result.getFirst();
    return await this.find({
      ...this.params,
      created: last != null ? {
        greater: last.created
      } : this.params.from != null ? { greaterOrEqual: this.params.from } : void 0,
      limit,
      order: import_communication_types.SortingOrder.Ascending
    });
  }
  // Load prev
  async loadPrevMessages(result) {
    const messages = [];
    const prevBuffer = this.prev.buffer;
    const last = prevBuffer[prevBuffer.length - 1];
    let fromDb = false;
    if (this.prev.hasMessages) {
      const prevMessages = await this.findPrevMessages(this.limit, result);
      const first = prevMessages[0];
      this.prev.hasMessages = prevMessages.length > 0;
      if (last == null) {
        messages.push(...prevMessages);
        fromDb = true;
      } else if (first != null && first.created < last.created) {
        messages.push(...prevMessages);
        fromDb = true;
      } else {
        const toPush = this.prev.buffer.splice(-this.limit).reverse();
        messages.push(...toPush);
      }
    }
    if (messages.length >= this.limit) return { messages, fromDb };
    const restLimit = this.limit - messages.length;
    const fromBuffer = this.prev.buffer.splice(-restLimit).reverse();
    messages.push(...fromBuffer);
    if (messages.length >= this.limit) return { messages, fromDb: false };
    while (this.prev.hasGroups || this.groupsBuffer.length > 0) {
      await this.loadGroups(import_types.Direction.Backward, result);
      const rest = this.limit - messages.length;
      const fromBuffer2 = this.prev.buffer.splice(-rest).reverse();
      messages.push(...fromBuffer2);
      if (messages.length >= this.limit) return { messages, fromDb: false };
    }
    return { messages, fromDb: false };
  }
  async findPrevMessages(limit, result) {
    if (!this.prev.hasMessages || result.isHead()) return [];
    const first = this.params.order === import_communication_types.SortingOrder.Ascending ? result.getFirst() : result.getLast();
    return await this.find({
      ...this.params,
      created: first != null ? {
        less: first?.created
      } : this.params.from != null ? { lessOrEqual: this.params.from } : void 0,
      limit,
      order: import_communication_types.SortingOrder.Descending
    });
  }
  getLoadGroupsParams(direction) {
    if (direction === import_types.Direction.Forward) {
      if (this.lastGroup != null) {
        return {
          fromDate: {
            greater: this.lastGroup.fromDate
          }
        };
      }
      if (this.params.from instanceof Date) {
        return {
          toDate: {
            greaterOrEqual: this.params.from
          }
        };
      }
    }
    if (direction === import_types.Direction.Backward) {
      if (this.firstGroup != null) {
        return {
          fromDate: {
            less: this.firstGroup.fromDate
          }
        };
      }
      if (this.params.from instanceof Date) {
        return {
          fromDate: {
            lessOrEqual: this.params.from
          }
        };
      }
    }
    return void 0;
  }
  async loadGroups(direction, result) {
    let messagesCount = 0;
    const lastResult = result.getLast();
    const toLoad = [];
    const toBuffer = [];
    while (messagesCount < this.limit) {
      if (this.lastGroupsDirection !== direction && this.groupsBuffer.length > 0) {
        this.groupsBuffer.length = 0;
        this.lastGroup = this.lastLoadedGroup;
        this.firstGroup = this.firstLoadedGroup;
        if (this.lastGroupsDirection === import_types.Direction.Backward) {
          this.prev.hasGroups = true;
        } else if (this.lastGroupsDirection === import_types.Direction.Forward) {
          this.next.hasGroups = true;
        }
      }
      this.lastGroupsDirection = direction;
      const currentGroups = this.groupsBuffer.splice(direction === import_types.Direction.Forward ? 0 : -GROUPS_LIMIT, GROUPS_LIMIT);
      const hasGroups = direction === import_types.Direction.Forward ? this.next.hasGroups : this.prev.hasGroups;
      if (currentGroups.length === 0 && !hasGroups) break;
      const groups = currentGroups.length > 0 ? currentGroups : await this.findGroups(direction, this.getLoadGroupsParams(direction));
      if (currentGroups.length === 0) {
        this.firstGroup = direction === import_types.Direction.Forward ? this.firstGroup ?? groups[0] : groups[groups.length - 1];
        this.lastGroup = direction === import_types.Direction.Forward ? groups[groups.length - 1] ?? this.lastGroup : this.lastGroup ?? groups[0];
        if (direction === import_types.Direction.Forward) {
          this.next.hasGroups = groups.length >= GROUPS_LIMIT;
        } else {
          this.prev.hasGroups = groups.length >= GROUPS_LIMIT;
        }
        if (this.isOneMessageQuery(this.params)) {
          this.next.hasGroups = false;
          this.prev.hasGroups = false;
        }
      }
      const orderedGroups = direction === import_types.Direction.Forward ? groups : groups.reverse();
      while (messagesCount < this.limit && orderedGroups.length > 0) {
        const group = direction === import_types.Direction.Forward ? orderedGroups.shift() : orderedGroups.pop();
        if (group == null) break;
        toLoad.push(group);
        messagesCount += group.count;
      }
      this.firstLoadedGroup = direction === import_types.Direction.Forward ? this.firstLoadedGroup ?? toLoad[0] : toLoad[toLoad.length - 1];
      this.lastLoadedGroup = direction === import_types.Direction.Forward ? toLoad[toLoad.length - 1] ?? this.lastLoadedGroup : this.lastLoadedGroup ?? toLoad[0];
      while (orderedGroups.length > 0) {
        const group = direction === import_types.Direction.Forward ? orderedGroups.shift() : orderedGroups.pop();
        if (group == null) break;
        toBuffer.push(group);
        messagesCount += group.count;
      }
    }
    if (direction === import_types.Direction.Forward) {
      this.groupsBuffer.push(...toBuffer);
    } else {
      this.groupsBuffer.unshift(...toBuffer);
    }
    const parsedFiles = await Promise.all(toLoad.map((group) => this.loadMessagesFromFiles(group)));
    for (const file of parsedFiles) {
      if (file.messages.length === 0) continue;
      if (direction === import_types.Direction.Forward) {
        const firstInFile = file.messages[0];
        const queryDate = lastResult != null && firstInFile.created < lastResult?.created ? lastResult?.created : void 0;
        const { next, prev } = this.matchFileMessages(file, direction, result, queryDate);
        this.next.buffer.push(...next);
        this.prev.buffer.push(...prev);
      } else {
        const lastInFile = file.messages[file.messages.length - 1];
        const queryDate = lastResult != null && lastInFile.created > lastResult?.created ? lastResult?.created : void 0;
        const matched = this.matchFileMessages(file, direction, result, queryDate);
        this.prev.buffer.unshift(...matched.prev);
        this.next.buffer.push(...matched.next);
      }
    }
  }
  matchFileMessages(file, direction, queryResult, filterDate) {
    let result = file.messages;
    const params = this.params;
    if (this.isOneMessageQuery(params)) {
      const msg = file.messages.find((it) => it.id === params.id);
      result = msg != null ? [msg] : [];
    }
    if (filterDate != null) {
      result = this.params.order === import_communication_types.SortingOrder.Ascending ? result.filter((it) => it.created > filterDate) : result.filter((it) => it.created < filterDate);
    }
    let prevResult = [];
    let nextResult = [];
    const from = this.initialized ? void 0 : this.params.from;
    const firstFromQueryResult = params.order === import_communication_types.SortingOrder.Ascending ? queryResult.getFirst() : queryResult.getLast();
    const lastFromFile = result[result.length - 1];
    if (from instanceof Date) {
      for (const message of result) {
        const isNext = params.order === import_communication_types.SortingOrder.Ascending ? message.created >= from : message.created > from;
        if (isNext) {
          nextResult.push(message);
        } else {
          prevResult.push(message);
        }
      }
    } else if (direction === import_types.Direction.Backward && (firstFromQueryResult == null || lastFromFile.created < firstFromQueryResult.created)) {
      prevResult = result;
    } else {
      nextResult = result;
    }
    return { next: nextResult, prev: prevResult };
  }
  async loadMessagesFromFiles(group) {
    const parsedFile = await (0, import_communication_yaml.loadGroupFile)(this.workspace, this.filesUrl, group.blobId, { retries: 5 });
    const patches = group.patches ?? [];
    const patchesMap = /* @__PURE__ */ new Map();
    for (const patch of patches) {
      patchesMap.set(patch.messageId, [...patchesMap.get(patch.messageId) ?? [], patch]);
    }
    return {
      ...parsedFile,
      messages: patches.length > 0 ? parsedFile.messages.map(
        (message) => (0, import_communication_shared.applyPatches)(message, patchesMap.get(message.id) ?? [], this.allowedPatches())
      ) : parsedFile.messages
    };
  }
  async findGroupByDate(params) {
    const groups = await this.client.findMessagesGroups({
      card: this.params.card,
      fromDate: { lessOrEqual: params },
      toDate: { greaterOrEqual: params },
      limit: 1,
      order: import_communication_types.SortingOrder.Ascending,
      orderBy: "fromDate"
    });
    return groups[0];
  }
  async findGroups(direction, date) {
    if (this.isOneMessageQuery(this.params)) {
      const group = await this.findGroupByDate(this.params.created);
      return group !== void 0 ? [group] : [];
    }
    if (date == null) {
      return await this.client.findMessagesGroups({
        card: this.params.card,
        limit: GROUPS_LIMIT,
        order: direction === import_types.Direction.Forward ? import_communication_types.SortingOrder.Ascending : import_communication_types.SortingOrder.Descending,
        orderBy: "fromDate"
      });
    }
    return await this.client.findMessagesGroups({
      card: this.params.card,
      limit: GROUPS_LIMIT,
      order: direction === import_types.Direction.Forward ? import_communication_types.SortingOrder.Ascending : import_communication_types.SortingOrder.Descending,
      orderBy: "fromDate",
      ...date
    });
  }
  async find(params) {
    delete params.from;
    delete params.strict;
    return await this.client.findMessages(params, this.id);
  }
  isOneMessageQuery(params) {
    return "id" in this.params && this.params.id != null;
  }
  async notify() {
    this.initialized = true;
    if (this.callback == null) return;
    if (this.result instanceof Promise) this.result = await this.result;
    const result = this.result.getResult();
    this.callback(new import_window.WindowImpl(result, this.result.getTotal(), this.result.isTail(), this.result.isHead(), this));
  }
  match(message) {
    if (this.isOneMessageQuery(this.params) && this.params.id !== message.id) {
      return false;
    }
    if (this.params.card !== message.cardId) {
      return false;
    }
    return true;
  }
  patchMessage(origin) {
    let message = origin;
    const patches = this.createdPatches.get(message.id) ?? [];
    message = (0, import_communication_shared.applyPatches)(message, patches, this.allowedPatches());
    return message;
  }
  async onMessageCreatedEvent(event) {
    if (this.params.card !== event.cardId || event.messageId == null) return;
    if (this.result instanceof Promise) this.result = await this.result;
    let message = import_communication_shared.MessageProcessor.createFromEvent(event);
    const exists = this.result.get(message.id);
    if (exists !== void 0) {
      this.cleanCache(message.id);
      return;
    }
    if (!this.match(message)) return;
    message = this.patchMessage(message);
    if (this.params.strict === true && this.params.limit != null && this.result.length >= this.params.limit) {
      this.result.unshift(message);
      this.result.sort(
        (a, b) => this.params.order === import_communication_types.SortingOrder.Ascending ? a.created.getTime() - b.created.getTime() : b.created.getTime() - a.created.getTime()
      );
      if (this.params.order === import_communication_types.SortingOrder.Descending && this.result.length > this.params.limit) {
        this.result.pop();
      } else if (this.params.order === import_communication_types.SortingOrder.Ascending && this.result.length > this.params.limit) {
        this.result.shift();
      }
      await this.notify();
      return;
    }
    if (this.result.isTail()) {
      let shouldResort2 = function(order) {
        if (firstMessage == null || lastMessage == null) return false;
        if (order === import_communication_types.SortingOrder.Ascending) {
          return lastMessage.created > message.created;
        }
        return firstMessage.created > message.created;
      };
      var shouldResort = shouldResort2;
      __name(shouldResort2, "shouldResort");
      const eventId = event._id;
      if (eventId != null) {
        const tmp = this.tmpMessages.get(eventId);
        if (tmp != null) this.result.delete(tmp);
        this.tmpMessages.delete(eventId);
      }
      const lastMessage = this.result.getLast();
      const firstMessage = this.result.getFirst();
      if (this.params.order === import_communication_types.SortingOrder.Ascending) {
        if (message.created.getTime() > (firstMessage?.created?.getTime() ?? 0) || this.result.length < this.limit) {
          this.result.push(message);
        } else {
          this.result.setHead(false);
        }
      } else {
        if (message.created.getTime() >= (lastMessage?.created?.getTime() ?? 0) || this.result.length < this.limit) {
          this.result.unshift(message);
        } else {
          this.result.setHead(false);
        }
      }
      if (shouldResort2(this.params.order ?? import_communication_types.SortingOrder.Ascending)) {
        this.result.sort(
          (a, b) => this.params.order === import_communication_types.SortingOrder.Ascending ? a.created.getTime() - b.created.getTime() : b.created.getTime() - a.created.getTime()
        );
      }
      void this.notify();
    }
    this.cleanCache(message.id);
  }
  cleanCache(message) {
    this.createdPatches.delete(message);
  }
  async onPatchEvent(event) {
    if (this.params.card !== event.cardId) return;
    const allowedPatches = this.allowedPatches();
    const eventPatches = import_communication_shared.MessageProcessor.eventToPatches(event).filter((it) => allowedPatches.includes(it.type));
    if (eventPatches.length === 0) return;
    if (this.result instanceof Promise) this.result = await this.result;
    const { messageId } = event;
    const message = this.result.get(messageId);
    if (message !== void 0) {
      const updatedMessage = (0, import_communication_shared.applyPatches)(message, eventPatches, this.allowedPatches());
      this.result.update(updatedMessage);
      await this.notify();
    } else {
      const currentPatches = this.createdPatches.get(messageId) ?? [];
      const patches = currentPatches.concat(eventPatches);
      this.createdPatches.set(messageId, patches);
      this.next.buffer = this.next.buffer.map((it) => {
        if (it.id === event.messageId) {
          this.createdPatches.delete(messageId);
          return (0, import_communication_shared.applyPatches)(it, eventPatches, this.allowedPatches());
        }
        return it;
      });
      this.prev.buffer = this.next.buffer.map((it) => {
        if (it.id === event.messageId) {
          this.createdPatches.delete(messageId);
          return (0, import_communication_shared.applyPatches)(it, eventPatches, this.allowedPatches());
        }
        return it;
      });
    }
  }
  allowedPatches() {
    const result = [import_communication_types.PatchType.update, import_communication_types.PatchType.remove];
    if (this.params.reactions === true) {
      result.push(import_communication_types.PatchType.reaction);
    }
    if (this.params.attachments === true) {
      result.push(import_communication_types.PatchType.attachment);
    }
    if (this.params.replies === true) {
      result.push(import_communication_types.PatchType.thread);
    }
    return result;
  }
  async refresh() {
    const nextPagesCount = this.nexLoadedPagesCount;
    const prevPagesCount = this.prevLoadedPagesCount;
    this.nexLoadedPagesCount = 0;
    this.prevLoadedPagesCount = 0;
    this.groupsBuffer = [];
    this.firstGroup = void 0;
    this.lastGroup = void 0;
    this.firstLoadedGroup = void 0;
    this.lastLoadedGroup = void 0;
    this.lastGroupsDirection = void 0;
    this.next.hasMessages = true;
    this.next.hasGroups = true;
    this.next.buffer = [];
    this.prev.hasMessages = true;
    this.prev.hasGroups = true;
    this.prev.buffer = [];
    this.createdPatches.clear();
    this.tmpMessages.clear();
    this.result = new import_result.QueryResult([], (x) => x.id);
    this.initialized = false;
    if (this.isInitLoadingForward()) {
      this.result.setHead(this.params.from == null);
    } else {
      this.result.setTail(this.params.from == null);
    }
    for (let i = 0; i < nextPagesCount; i++) {
      const { isDone } = await this.requestLoadNextPage(false);
      this.initialized = true;
      if (!isDone) break;
    }
    for (let i = 0; i < prevPagesCount; i++) {
      const { isDone } = await this.requestLoadPrevPage(false);
      this.initialized = true;
      if (!isDone) break;
    }
    await this.notify();
  }
}
//# sourceMappingURL=query.js.map
